 
import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearBusinessPolicyIntrestedState, fetchBusinessPolicyIntrestedListAsync } from "../../../../../../redux/businessPolicy/businessPolicyInterested/businessPolicyInterestedActions";

export const useBusinessIntrestedParty = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();

    const InterestedParty = useSelector(
      (storeState: IStoreState) => storeState.business.interested.data
    );

  const interestedPartyDropDown = React.useMemo(() => {
    return InterestedParty.map((item) => {
      return {
        label: `${item.incremental_number}, Interested Party: ${item.interested_party_code})`,
        value: item.incremental_number || "",
      };
    });
  }, [InterestedParty]);

  const refreshData = () => {
    if (customerPolicyId) {
      dispatch(fetchBusinessPolicyIntrestedListAsync(Number(customerPolicyId), "ACTIVE"));
    }
  }


    React.useEffect(() => {
      if (customerPolicyId) {
        dispatch(fetchBusinessPolicyIntrestedListAsync(Number(customerPolicyId), "ACTIVE"));
      }
      return(()=>{
        dispatch(clearBusinessPolicyIntrestedState());
      })
    }, []);
  


  return { interestedPartyDropDown,interestedPartyList: InterestedParty, refreshData };
};
